// @flow

import { getTrackingCode } from '~/tracking/utils';
import { getOrigin, getTrackingCodes } from '~/common/selectors/trovit';

export const trackingCodeByOriginSelector = (state: Object) => {
  const trackingCodes = getTrackingCodes(state);
  const origin = getOrigin(state);

  const trackingCode = getTrackingCode(origin, trackingCodes);

  if (!trackingCode) {
    return null;
  }

  return trackingCode.code;
};



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/selectors.js